import { ColorResult, SketchPicker, SketchPickerProps } from 'react-color';
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';

import { ClickAwayListener } from '@mui/material';
import { Box } from '@mui/system';
import { useState } from 'react';
type OwnProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>> = {
    name: TName;
    control: Control<TFieldValues>;
    rules?: Omit<RegisterOptions<TFieldValues, TName>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
} & SketchPickerProps;

export function FormColorPicker<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
    name,
    control,
    rules
}: OwnProps<TFieldValues, TName>) {
    const [visible, setVisible] = useState(false);
    const styles = val => ({
        color: {
            width: '36px',
            height: '14px',
            borderRadius: '2px',
            background: `${val}`
        },
        swatch: {
            padding: '5px',
            background: '#fff',
            borderRadius: '1px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
            display: 'inline-block',
            cursor: 'pointer'
        },
        popover: {
            position: 'absolute',
            zIndex: '2'
        },
        cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px'
        }
    });
    const popover = {
        position: 'absolute',
        zIndex: '2000'
    };
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field: { onChange, value } }) => (
                <>
                    <Box sx={{ ...styles(value).swatch }} onClick={() => setVisible(!visible)}>
                        <Box sx={{ ...styles(value).color }}></Box>
                    </Box>
                    {visible && (
                        <ClickAwayListener onClickAway={() => setVisible(false)}>
                            <Box sx={{ ...popover, display: 'inline-flex' }}>
                                <SketchPicker
                                    onChangeComplete={(color: ColorResult) => {
                                        console.log(color);
                                        onChange(color?.hex ?? '');
                                    }}
                                    color={value ?? 'transparent'}
                                />
                            </Box>
                        </ClickAwayListener>
                    )}
                </>
            )}
        />
    );
}
